export const formatUrlString = (input: string) => {
  return decodeURIComponent(input)
    .replace(/[^a-zA-Z0-9\s]/g, '')
    .replace(/\s+/g, '-')
    .toLowerCase();
};
